import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { LayoutDashboard, MessageSquare, CreditCard, LogOut, Wifi, User } from 'lucide-react';

export default function CustomerLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/portal/login');
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      {/* Top nav for customer portal */}
      <header style={{
        background: 'var(--bg-sidebar)', padding: '0 24px', height: 60,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        position: 'sticky', top: 0, zIndex: 50
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Wifi size={20} color="var(--accent)" />
          <span style={{ color: '#fff', fontWeight: 700, fontSize: '1rem' }}>
            My<span style={{ color: 'var(--accent)' }}>ISP</span> Portal
          </span>
        </div>

        <nav style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          {[
            { to: '/portal', icon: LayoutDashboard, label: 'My Account' },
            { to: '/portal/wifi', icon: Wifi, label: 'My WiFi' },
            { to: '/portal/profile', icon: User, label: 'Profile' },
            { to: '/portal/payments', icon: CreditCard, label: 'Payments' },
            { to: '/portal/complaints', icon: MessageSquare, label: 'Support' },
          ].map(({ to, icon: Icon, label }) => (
            <NavLink key={to} to={to} end={to === '/portal'}
              style={({ isActive }) => ({
                display: 'flex', alignItems: 'center', gap: 6,
                padding: '6px 12px', borderRadius: 6,
                color: isActive ? '#fff' : 'rgba(255,255,255,.6)',
                background: isActive ? 'rgba(37,99,235,.3)' : 'transparent',
                textDecoration: 'none', fontSize: '.85rem', fontWeight: 500
              })}
            >
              <Icon size={15} />{label}
            </NavLink>
          ))}
          <button
            onClick={handleLogout}
            style={{
              marginLeft: 8, display: 'flex', alignItems: 'center', gap: 6,
              padding: '6px 12px', borderRadius: 6, background: 'none',
              border: '1px solid rgba(255,255,255,.2)', color: 'rgba(255,255,255,.6)',
              cursor: 'pointer', fontSize: '.85rem'
            }}
          >
            <LogOut size={14} /> Sign Out
          </button>
        </nav>
      </header>

      <main style={{ maxWidth: 900, margin: '0 auto', padding: '28px 20px' }}>
        <Outlet />
      </main>
    </div>
  );
}
